module.exports = __webpack_public_path__ + "img/load.a1887c1d.gif";